!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports["react-upload-file"] = t(require("react")) : e["react-upload-file"] = t(e.React);
}(this, function (e) {
  return function (e) {
    function t(r) {
      if (o[r]) return o[r].exports;
      var n = o[r] = {
        exports: {},
        id: r,
        loaded: !1
      };
      return e[r].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports;
    }
    var o = {};
    return t.m = e, t.c = o, t.p = "", t(0);
  }([function (e, t, o) {
    e.exports = o(1);
  }, function (e, t, o) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function n(e) {
      if (Array.isArray(e)) {
        for (var t = 0, o = Array(e.length); t < e.length; t++) o[t] = e[t];
        return o;
      }
      return Array.from(e);
    }
    function i(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function s(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function p(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var a = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var o = arguments[t];
          for (var r in o) Object.prototype.hasOwnProperty.call(o, r) && (e[r] = o[r]);
        }
        return e;
      },
      u = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      },
      l = function () {
        function e(e, t) {
          for (var o = 0; o < t.length; o++) {
            var r = t[o];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, o, r) {
          return o && e(t.prototype, o), r && e(t, r), t;
        };
      }(),
      c = o(2),
      f = r(c),
      d = function (e) {
        function t(e) {
          i(this, t);
          var o = s(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          o.state = {
            xhrList: [],
            currentXHRId: 0
          }, o.commonChooseFile = function (e) {
            if ("ajax-upload-file-input" !== e.target.name) {
              var t = o.beforeChoose();
              if (t !== !0 && void 0 !== t) return;
              o.input.click();
            }
          }, o.commonChangeFile = function (e) {
            o.files = o.input.files, o.didChoose(o.files), o.props.uploadFileButton || o.commonUploadFile(e);
          }, o.commonUploadFile = function (e) {
            if (!o.files || !o.files.length) return !1;
            if (!o.baseUrl) throw new Error("baseUrl missed in options");
            var t = e === !0 || o.beforeUpload(o.files);
            if (!t) return !1;
            var r = new FormData();
            r = o.appendFieldsToFormData(r);
            for (var i = u(o.fileFieldName), s = 0 === o.numberLimit ? o.files.length : Math.min(o.files.length, o.numberLimit), p = s - 1; p >= 0; p--) if ("function" === i) {
              var a = o.files[p],
                l = o.fileFieldName(a);
              r.append(l, a);
            } else if ("string" === i) {
              var c = o.files[p];
              r.append(o.fileFieldName, c);
            } else {
              var f = o.files[p];
              r.append(f.name, f);
            }
            var d = o.baseUrl,
              y = "function" == typeof o.query ? o.query(o.files) : o.query,
              m = d.indexOf("?"),
              h = void 0;
            if (m > -1 && (h = d.substring(m), d = d.substring(0, m)), y) {
              h && console.warn("Your url contains query string, which will be ignored when options.query is set.");
              var b = [];
              Object.keys(y).forEach(function (e) {
                return b.push(e + "=" + y[e]);
              }), h = "?" + b.join("&");
            }
            h = h || "";
            var T = "" + d + h,
              v = new XMLHttpRequest();
            v.open("post", T, !0), v.withCredentials = o.withCredentials;
            var P = o.requestHeaders;
            P && Object.keys(P).forEach(function (e) {
              return v.setRequestHeader(e, P[e]);
            }), o.timeout && (v.timeout = o.timeout, v.addEventListener("timeout", function () {
              o.uploadError({
                type: "408",
                message: "Request Timeout"
              });
            }), setTimeout(function () {}, o.timeout)), v.addEventListener("load", function () {
              o.input.value = "";
              var e = "json" === o.dataType ? JSON.parse(v.responseText) : v.responseText;
              o.uploadSuccess(e);
            }), v.addEventListener("error", function () {
              var e = "json" === o.dataType ? JSON.parse(v.responseText) : v.responseText;
              o.uploadError({
                type: e.type,
                message: e.message
              });
            }), v.addEventListener("progress", function (e) {
              o.uploading(e);
            });
            var g = o.state.xhrList.length - 1;
            return v.addEventListener("abort", function () {
              o.onAbort(g);
            }), v.send(r), o.setState({
              currentXHRId: g,
              xhrList: [].concat(n(o.state.xhrList), [v])
            }), o.didUpload(o.files, o.state.currentXHRId), !0;
          }, o.appendFieldsToFormData = function (e) {
            var t = "function" == typeof o.body ? o.body() : o.body;
            return t && Object.keys(t).forEach(function (o) {
              e.append(o, t[o]);
            }), e;
          }, o.processFile = function (e) {
            o.files = e(o.files);
          }, o.manuallyChooseFile = function (e) {
            o.commonChooseFile(e);
          }, o.manuallyUploadFile = function (e) {
            o.files = e && e.length ? e : o.files, o.commonUploadFile(!0);
          }, o.abort = function (e) {
            e ? o.state.xhrList[e].abort() : o.state.xhrList[o.state.currentXHRId].abort();
          };
          var r = function r(e) {
              return e;
            },
            p = a({
              dataType: "json",
              timeout: 0,
              numberLimit: 0,
              userAgent: window ? window.navigator.userAgent : "",
              multiple: !1,
              withCredentials: !1,
              beforeChoose: r,
              didChoose: r,
              beforeUpload: r,
              didUpload: r,
              uploading: r,
              uploadSuccess: r,
              uploadError: r,
              uploadFail: r,
              onAbort: r
            }, e.options),
            l = parseInt(p.timeout, 10);
          p.timeout = Number.isInteger(l) && l > 0 ? l : 0;
          var c = p.dataType && p.dataType.toLowerCase();
          return p.dataType = "json" !== c && "text", Object.keys(p).forEach(function (e) {
            o[e] = p[e];
          }), o;
        }
        return p(t, e), l(t, [{
          key: "render",
          value: function value() {
            var e = this,
              t = {
                accept: this.props.options.accept,
                multiple: this.props.options.multiple
              },
              o = f.default.cloneElement(this.props.chooseFileButton, {
                onClick: this.commonChooseFile
              }, [].concat(n(this.props.chooseFileButton.props.children ? [this.props.chooseFileButton.props.children] : []), [f.default.createElement("input", a({
                type: "file",
                ref: function ref(t) {
                  return e.input = t;
                },
                name: this.props.inputName || "ajax-upload-file-input",
                style: {
                  display: "none"
                },
                onChange: this.commonChangeFile
              }, t, {
                key: "file-button"
              }))])),
              r = this.props.uploadFileButton && f.default.cloneElement(this.props.uploadFileButton, {
                onClick: this.commonUploadFile
              });
            return f.default.createElement("div", {
              style: {
                display: "inline-block"
              }
            }, o, r);
          }
        }]), t;
      }(c.Component);
    d.propTypes = {
      options: c.PropTypes.shape({
        baseUrl: c.PropTypes.string.isRequired,
        query: c.PropTypes.oneOfType([c.PropTypes.object, c.PropTypes.func]),
        body: c.PropTypes.oneOfType([c.PropTypes.object, c.PropTypes.func]),
        dataType: c.PropTypes.string,
        timeout: c.PropTypes.number,
        numberLimit: c.PropTypes.oneOfType([c.PropTypes.number, c.PropTypes.func]),
        fileFieldName: c.PropTypes.oneOfType([c.PropTypes.string, c.PropTypes.func]),
        withCredentials: c.PropTypes.bool,
        requestHeaders: c.PropTypes.object,
        accept: c.PropTypes.string,
        multiple: c.PropTypes.bool,
        userAgent: c.PropTypes.string,
        beforeChoose: c.PropTypes.func,
        didChoose: c.PropTypes.func,
        beforeUpload: c.PropTypes.func,
        didUpload: c.PropTypes.func,
        uploading: c.PropTypes.func,
        uploadSuccess: c.PropTypes.func,
        uploadError: c.PropTypes.func,
        uploadFail: c.PropTypes.func,
        onAbort: c.PropTypes.func
      }).isRequired,
      style: c.PropTypes.object,
      className: c.PropTypes.string,
      chooseFileButton: c.PropTypes.element.isRequired,
      uploadFileButton: c.PropTypes.element
    }, d.defaultProps = {
      chooseFileButton: f.default.createElement("button", null, "Select File")
    }, t.default = d;
  }, function (t, o) {
    t.exports = e;
  }]);
});